export default [
  {
    path: '/admin/pos/restaurant-sales',
    name: 'restaurant-sale',
    meta: { requiresAuth: true },
    component: () => import('@/pages/restaurant-sale/index.vue')
  },
  {
    path: '/admin/pos/counter-checkouts',
    name: 'counter-checkout',
    meta: { requiresAuth: true },
    component: () => import('@/pages/restaurant-sale/counter-checkout.vue')
  }
]
